import { render, staticRenderFns } from "./PersonnelSelection.vue?vue&type=template&id=7924d663&scoped=true&"
import script from "./PersonnelSelection.vue?vue&type=script&lang=js&"
export * from "./PersonnelSelection.vue?vue&type=script&lang=js&"
import style0 from "./PersonnelSelection.vue?vue&type=style&index=0&id=7924d663&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7924d663",
  null
  
)

export default component.exports